module.exports = __webpack_public_path__ + "img/02_noff_open_L3.d8809426.svg";